import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/charges')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.charges.crumb" icon={PercentageIcon} />,
      title: <CrumbTitle id="configurationManagement.charges.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
